import script from "./icon-two-tones-tiktok.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-tiktok.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-tiktok.vue?vue&type=style&index=0&id=5cfa94a1&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfa94a1"]])

export default __exports__